import React from "react";

export const createInputClassName = (field) => {
    const error = field.meta.error;
    const touched = field.meta.touched;
    const dirty = field.meta.dirty;
    const asyncValidating = field.meta.asyncValidating;
    const className = field.className + (asyncValidating ? ' async-validating' : ((touched || dirty) ? (error ? ' has-error' : ' is-valid') : ''));
    return className;
};

export const renderControl = (field, control) => {
    return <li className={field.wrapperClassName + (field.required ? " required" : "")}>
        <label htmlFor={field.input.id}>{field.label}</label>
        {control}
        <span className="feedback"></span>
        {field.useInnerHtmlForError && field.meta.error && <div id={field.input.name + "Error"} className="error" dangerouslySetInnerHTML={{__html: field.meta.error}} />}
        {field.useInnerHtmlForError &&field.extraErrors && field.extraErrors.length > 0 && field.extraErrors.map((e, i) => <div id={field.input.name + "ExtraError" + i} className="red" dangerouslySetInnerHTML={{__html: e}} />)}
        {!field.useInnerHtmlForError && field.meta.error && <div id={field.input.name + "Error"} className="error">{field.meta.error}</div>}
        {!field.useInnerHtmlForError &&field.extraErrors && field.extraErrors.length > 0 && field.extraErrors.map((e, i) => <div id={field.input.name + "ExtraError" + i} className="red">{e}</div>)}
    </li>;
};

export const renderInput = (field) => {
    const className = createInputClassName(field);
    const id = field.id ? field.id : field.input.name;
    const inputProps = {
        ...field.input,
        className,
        id,
        type: field.type,
        disabled: field.disabled,
        onBlur: (e) => {
            field.input.onBlur(e);
            if (field.blurHandler) {
                field.blurHandler(e);
            }
        },
        onFocus: (e) => {
            field.input.onFocus(e);
            if (field.focusHandler) {
                field.focusHandler(e);
            }
        },
        onChange: (e) => {
            field.input.onChange(e);
            if (field.changeHandler){
                field.changeHandler(e);
            }

        }
    };
    if (field.autoFocus){
        inputProps.autoFocus = true;
    }
    return renderControl(field, <input {...inputProps} />);
};

export const renderSelect = (field) => {
    const {optionValueField, optionLabelField} = field;
    const className = createInputClassName(field);
    const id = field.id ? field.id : field.input.name;
    const inputProps = {
        ...field.input,
        id,
        className,
        disabled: field.disabled,
        onChange: (e) => {
            field.input.onChange(e);
            if (field.changeHandler){
                field.changeHandler(e);
            }
        }
    };
    if (field.autoFocus){
        inputProps.autoFocus = true;
    }

    return renderControl(field,
        <select {...inputProps}>
            {
                field.options &&
                field.options.map(o => (<option
                    value={optionValueField && optionValueField.length ? o[optionValueField] : o}>{
                    optionLabelField && optionLabelField.length ? o[optionLabelField] : o
                }</option>))
            }
        </select>
    );
};

export const simpleRenderInput = (field) => {
    const inputProps = {...field.input,
        type: field.type,
        disabled: field.disabled
    };
    return <input {...inputProps} />;

};


export const renderCheckbox = (field) => {
    const id = field.id ? field.id : field.input.name;
    const checkBoxProps = {
        ...field.input,
        className: createInputClassName(field),
        type: "checkbox",
        id,
        disabled: field.disabled
    };
    const useInnerHtmlForLabel = field.useInnerHtmlForLabel;

    return (
        <li className={(field.required ? " required" : "")}>
            <input {...checkBoxProps} />
            {!useInnerHtmlForLabel && <label htmlFor={id} className="display--inline-block soft-half--left">{field.label}</label>}
            {useInnerHtmlForLabel && <label htmlFor={id} className="display--inline-block soft-half--left" dangerouslySetInnerHTML={{__html: field.label}} />}
            <span className="feedback"></span>
            {field.meta.error && <div id={id  + "Error"} className="error">{field.meta.error}</div>}
        </li>
    );
};